@if (loading) {
  <kendo-loader type="converging-spinner" size="large" style="margin: auto"></kendo-loader>
} @else {
  <div class="container-fluid mt-4">
    <form novalidate [formGroup]="projectPlanningForm">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label for="ConstructionStart">Construction Start</label>
            <kendo-datepicker id="ConstructionStart" #ConstructionStart class="prelabel" class="form-control"
              [disabledControl]="true" formControlName="ConstructionStart"></kendo-datepicker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="ConstructionEnd">Construction End</label>
            <kendo-datepicker id="ConstructionEnd" #ConstructionEnd class="prelabel" class="form-control"
              [disabledControl]="true" formControlName="ConstructionEnd"></kendo-datepicker>
          </div>
        </div>
        @if (canEditNeedByDate) {
          <div kendoTooltip class="col-md-3">
            <div class="form-group">
              <label for="TargetCompleteDate">Need By Date</label>
              <kendo-datepicker id="TargetCompleteDate" #TargetCompleteDate class="prelabel" class="form-control"
                [disabled]="false" formControlName="TargetCompleteDate"></kendo-datepicker>
            </div>
          </div>
        } @else {
          <div kendoTooltip class="col-md-3" title="Earliest Pad's Rig Release Date">
            <div class="form-group">
              <label for="EarliestPadRigRelease">Need By Date</label>
              <kendo-datepicker id="EarliestPadRigRelease" class="prelabel" class="form-control"
                [disabledControl]="true" formControlName="EarliestPadRigRelease"></kendo-datepicker>
            </div>
          </div>
        }
        @if (isTBProject) {
          <div class="col-md-3">
            <div class="form-group">
              <label for="EarliestPOP">Earliest POP</label>
              <kendo-datepicker id="EarliestPOP" class="prelabel" class="form-control"
                [disabledControl]="true" formControlName="EarliestPOP"></kendo-datepicker>
            </div>
          </div>
        }
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label for="DirtWorkContractor">Dirt Work Contractor</label>
            <kendo-combobox class="form-control" formControlName="DirtWorkContractorId"
              [data]="dContractor"
              [textField]="'Name'"
              [valuePrimitive]="true"
              [valueField]="'ContractorId'">
            </kendo-combobox>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="ElectricalWorkContractor">Electrical Work Contractor</label>
            <kendo-combobox class="form-control" formControlName="ElectricalWorkContractorId"
              [data]="dContractor"
              [textField]="'Name'"
              [valuePrimitive]="true"
              [valueField]="'ContractorId'">
            </kendo-combobox>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="MechanicalContractor">Mechanical Contractor</label>
            <kendo-textbox type="text" class="form-control" formControlName="MechanicalContractor" [disabledControl]="true" />
          </div>
        </div>
      </div>
      <div class="flex-column flex-fill">
        <ag-grid-angular style="height: 800px;" class="ag-theme-balham"
          [gridOptions]="planningTasksGridOptions"
          [groupDefaultExpanded]="-1"
          (cellValueChanged)="onRowValueChanged($event)"
          (gridReady)="onGridReady($event)">
        </ag-grid-angular>
      </div>

    </form>
  </div>
}